<script>
  import { gdBias, gdWeight } from "../store";
  import katexify from "../katexify";
  import GradientDescentScatterplot from "./GradientDescentScatterplot.svelte";
  import GradientDescentErrorPlot from "./GradientDescentErrorPlot.svelte";
  import Hidden from "./Hidden.svelte";
  import { tooltip } from "../tooltip";
  import { format } from "d3-format";

  // instantiate class for gd methods
  let gdScatterClass;
  let gdErrorClass;
  let shown;
  let show;

  const formatter = format(".3f");
</script>


<br /><br />
<div id="gd-container">
  <div id="equations-container">
    <div id="bias-slider">
      <div class="input-container">
        <p>
          Bias ({@html katexify(`\\hat{\\beta_0}`, false)}): {formatter(
            $gdBias
          )}
        </p>
        <input
          type="range"
          min="-2"
          step="0.5"
          max="16"
          bind:value={$gdBias}
          class="slider"
          id="myRange"
        />
      </div>
    </div>
    <div id="weight-slider">
      <div class="input-container">
        <p>
          Weight ({@html katexify(`\\hat{\\beta_1}`, false)}): {formatter(
            $gdWeight
          )}
        </p>
        <input
          type="range"
          min="-1.5"
          max="6"
          step=".01"
          bind:value={$gdWeight}
          class="slider"
          id="myRange"
        />
      </div>
    </div>

    <div id="equation-math">
      Our model: {@html katexify(
        `\\begin{aligned} y = ${formatter($gdWeight)}x${
          $gdBias < 0 ? "" : "+"
        }${formatter($gdBias)}+c \\end{aligned}`
      )}
    </div>
    <div id="buttons-container">
      <button on:click={() => gdScatterClass.shuffleData()}>New Data</button>
      <button on:click={() => gdScatterClass.runGradientDescent(1)}
        >1 Step</button
      >
      <button on:click={() => gdScatterClass.runGradientDescent(25)}
        >25 Steps</button
      >
      <button on:click={() => gdScatterClass.runGradientDescent(100)}
        >100 Steps</button
      >
    </div>

  </div>
  <div id="charts-container">
    <div id="gd-chart-regression">
      <GradientDescentScatterplot bind:this={gdScatterClass} />
    </div>
    <div id="gd-chart-error">
      <GradientDescentErrorPlot bind:this={gdErrorClass} />
    </div>
  </div>
</div>
<style>
  :global(body, html) {
    height: 100%;
    margin: 0;
    padding: 0;
  }

  #gd-container {
    display: grid;
    grid-template-columns: 50% 50%;
    font-family: var(--font-mono);
    margin: auto;
    max-width: 1000px;
    height: 70vh;
    max-height: 500px;
  }

  #equations-container {
    text-align: center;
    flex-direction: column;
  }

  #equation-math {
    margin-bottom: 1rem;
  }

  .gd-math {
    margin: auto;
    max-width: 700px;
    border: 5px solid var(--smile);
    padding: 2rem;
    background-color: var(--paper);
  }

  #buttons-container {
    display: flex;
    margin: 8px auto;
    justify-content: space-around;
    align-items: center;
    width: 90%;
  }

  .input-container {
    margin: 8px auto;
    align-items: center;
    width: 80%;
  }

  button {
    background-color: var(--smile);
    border: none;
    color: white;
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 4px 2px;
    cursor: pointer;
  }

  button:hover {
    outline: 2px solid var(--squidink);
  }

  button:active {
    color: var(--squidink);
  }

  button:visited {
    color: var(--white);
  }

  button.show-button {
    background-color: var(--bg);
    border: none;
    color: var(--squidink);
    padding: 8px 16px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    margin: 4px 2px;
    cursor: pointer;
    outline: 2px solid var(--squidink);
  }

  .show-button-container {
    max-width: var(--max-width);
    display: flex;
    margin: 1rem auto;
    justify-content: center;
  }

  #charts-container {
    display: grid;
    grid-template-columns: 100%;
    grid-column-gap: 0rem;
    grid-template-rows: 60% 40%;
    height: 80vh;
    padding-right: 1rem;
    max-height: 500px;
  }

  #gd-chart-regression {
    width: 100%;
    height: 100%;
  }

  /* mobile */
  @media screen and (max-width: 950px) {
    #gd-container {
      grid-template-columns: 100%;
      max-width: 100%;
      width: 100%;
      height: 100%;
      max-height: 100%;
    }

    #charts-container {
      max-width: 100%;
    }

    .gd-math {
      border: none;
    }
  }
</style>
